import { DEFAULT_PAGINATION } from '../../bank-movements/constants/bankMovementsConstants';

const buildInitialFilters = () => {
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  const format = (date) => date.toISOString().split('T')[0];

  return {
    startDate: format(start),
    endDate: format(today),
    accountId: '',
  };
};

export const EXCHANGE_CHECKS_DEFAULT_FILTERS = buildInitialFilters();
export const EXCHANGE_CHECKS_ITEMS_PER_PAGE = DEFAULT_PAGINATION.rowsPerPage;

